































import { mapState } from "vuex";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconHeartOutline from "@/common/components/icons/IconHeartOutline.vue";
import IconHistory from "@/common/components/icons/IconHistory.vue";
import { Vue, Component, Prop } from "vue-property-decorator";
import globals from "@/general/store/modules/globals";

@Component({
  components: {
    ButtonMain,
    IconBase,
    IconHeartOutline,
    IconHistory
  }
})
export default class ItemEmptyPanel extends Vue {
  @Prop({ type: String, required: true, default: "" })
  text!: string;
  @Prop({ type: String, required: false, default: "" })
  type!: string;

  isSp = globals.isSpScreenWidth;

  get favoriteIconSize() {
    if (this.isSp) {
      return {
        width: 56,
        height: 48
      };
    } else {
      return {
        width: 80,
        height: 70
      };
    }
  }
  get historyIconSize() {
    if (this.isSp) {
      return {
        width: 53,
        height: 47
      };
    } else {
      return {
        width: 78,
        height: 69
      };
    }
  }
}
